var React = require('react');

function RightChevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,1.06,3.44,4.5,0,7.94,1.06,9l4.5-4.5L1.06,0Z"}));
}

RightChevron.defaultProps = {"viewBox":"0 0 5.56 9"};

module.exports = RightChevron;

RightChevron.default = RightChevron;
